const Quality=() => {
    return(
        <div>
        <h2>품질 관리</h2>
        </div>
    )
}

export default Quality;